<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { Primitive } from 'reka-ui';
import type { PrimitiveProps } from 'reka-ui';
import { Link2 as LinkIcon } from 'lucide-vue-next';
import { cn } from '@/lib/utils.ts';

const props = withDefaults(
    defineProps<
        PrimitiveProps & {
            class?: HTMLAttributes['class'];
            id?: string;
        }
    >(),
    {
        as: 'h1',
    }
);
</script>

<template>
    <Primitive
        :id="id"
        :as="as"
        :class="cn('heading', id && 'relative group/heading scroll-mt-20 -ml-4 pl-4', props.class)"
    >
        <a
            v-if="id"
            :href="`#${id}`"
            class="absolute left-0 top-1/2 -translate-y-1/2 opacity-0 transition-opacity group-hover/heading:opacity-100 text-muted-foreground text-sm font-normal no-underline select-none"
            aria-hidden="true"
            tabindex="-1"
        >#</a>
        <slot />
    </Primitive>
</template>
